var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69345",
    "data-name": "Group 69345",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.941,
    height: 143.954,
    viewBox: "0 0 150.941 143.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141846",
    "data-name": "Rectangle 141846",
    width: 150.941,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141840",
    "data-name": "Rectangle 141840",
    width: 150.94,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86063",
    "data-name": "Path 86063",
    d: "M65.143,58.038C63.75,59.072,23.559,59.87,20.15,69.854s28.218,34.577,28.762,36.675-9.538,40.539-1.991,45.72c4.193,2.879,16.435-2.224,26.856-7.328,8.338-4.083,15.511-8.167,16.462-8.162,2.137.012,37.187,20.566,43.317,15.489s-2.026-44.568-1.287-46.423,31.273-28.431,28.058-35.972-42.69-10.821-44.287-11.816-15.33-39.106-25.8-39.106S66.533,57,65.143,58.038",
    transform: "translate(-19.893 -18.932)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 0.849,
    x2: 0.127,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#ffeb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ffd54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141844",
    "data-name": "Rectangle 141844",
    width: 80.006,
    height: 16.727,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141842",
    "data-name": "Rectangle 141842",
    width: 18.119,
    height: 16.727,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69344",
    "data-name": "Group 69344",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69330",
    "data-name": "Group 69330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69329",
    "data-name": "Group 69329",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86062",
    "data-name": "Path 86062",
    d: "M75.484,0c11.234,0,26.721,39.375,28.437,40.444s43.309,6.1,46.758,14.19S122.126,91.99,121.333,93.982s7.2,43.6.625,49.052-44.18-15.851-46.474-15.864S37.108,148.592,29.01,143.033s1.209-46.8.625-49.052S-3.368,65.346.287,54.634s45.267-13.081,46.76-14.19S64.249,0,75.484,0",
    transform: "translate(0)",
    fill: "#ffbd39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69332",
    "data-name": "Group 69332",
    transform: "translate(5.138 4.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69331",
    "data-name": "Group 69331",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141841",
    "data-name": "Rectangle 141841",
    width: 201.367,
    height: 200.284,
    transform: "matrix(0.769, -0.64, 0.64, 0.769, -71.2, 56.65)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69343",
    "data-name": "Group 69343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69342",
    "data-name": "Group 69342",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86064",
    "data-name": "Path 86064",
    d: "M56.321,201.537c-.728-7.1,22.564-11.279,23.593-2.971s-22.6,12.645-23.593,2.971",
    transform: "translate(-41.763 -143.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86065",
    "data-name": "Path 86065",
    d: "M170.8,192.124c-.175-4.566,6.789-4.845,7.152-1.1.405,4.2-6.989,5.37-7.152,1.1",
    transform: "translate(-126.683 -139.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69341",
    "data-name": "Group 69341",
    transform: "translate(36.381 82.146)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69340",
    "data-name": "Group 69340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69339",
    "data-name": "Group 69339",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69335",
    "data-name": "Group 69335",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69334",
    "data-name": "Group 69334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69333",
    "data-name": "Group 69333",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86066",
    "data-name": "Path 86066",
    d: "M158.985,326.427c0,4.619-4.056,8.365-9.06,8.365s-9.059-3.745-9.059-8.365,4.056-8.363,9.059-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-140.866 -318.064)",
    fill: "#ff5f82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69338",
    "data-name": "Group 69338",
    transform: "translate(61.887)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69337",
    "data-name": "Group 69337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69336",
    "data-name": "Group 69336",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86067",
    "data-name": "Path 86067",
    d: "M398.606,326.427c0,4.619-4.056,8.365-9.06,8.365s-9.06-3.745-9.06-8.365,4.056-8.363,9.06-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-380.487 -318.064)",
    fill: "#ff5f82"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86068",
    "data-name": "Path 86068",
    d: "M272.853,371.207c1.919-3.232-.854-5.727-2.675-2.726-3.533,5.82-12.92,5.334-16.506,0-1.93-2.871-4.412-.69-2.674,2.726,4.11,8.078,16.5,9.02,21.856,0",
    transform: "translate(-185.737 -272.313)",
    fill: "#872a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86069",
    "data-name": "Path 86069",
    d: "M153.414,203.669c1-2.719-4.894-6.243-11.912-4.047-4.743,1.484-8.749,7.919-7.437,9.138s2.687-3.978,8.854-5.686c5.294-1.466,10.064,1.768,10.494.595",
    transform: "translate(-99.254 -147.556)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86070",
    "data-name": "Path 86070",
    d: "M374.446,203.669c-1-2.719,4.9-6.243,11.911-4.047,4.743,1.484,8.75,7.919,7.438,9.138s-2.687-3.978-8.855-5.686c-5.292-1.466-10.063,1.768-10.494.595",
    transform: "translate(-277.656 -147.556)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86071",
    "data-name": "Path 86071",
    d: "M152.142,290.271c-2.316-1.959,1.13-9.766,10.353-9.766s12.492,7.677,10.577,9.766c-1.656,1.806-3.689-3.778-10.352-3.778s-8.619,5.434-10.578,3.778",
    transform: "translate(-112.33 -208.059)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86072",
    "data-name": "Path 86072",
    d: "M349.957,290.271c-2.316-1.959,1.131-9.766,10.353-9.766s12.493,7.677,10.578,9.766c-1.657,1.806-3.689-3.778-10.353-3.778s-8.619,5.434-10.578,3.778",
    transform: "translate(-259.056 -208.059)",
    fill: "#541300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating3);
export default __webpack_public_path__ + "static/media/rating-3.7d853377a142cf1fbf8002172c7fba4a.svg";
export { ForwardRef as ReactComponent };